import { render } from "./TitleText.vue?vue&type=template&id=5eb6bf83&scoped=true"
import script from "./TitleText.vue?vue&type=script&lang=js"
export * from "./TitleText.vue?vue&type=script&lang=js"

import "./TitleText.vue?vue&type=style&index=0&id=5eb6bf83&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5eb6bf83"

export default script